var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mt-5 mb-2 text-center color-gray-darker"},[_vm._v(" "+_vm._s(_vm.$t("home.maintenance_number", { number: _vm.itemsCount }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }